(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feminine-cart-polish"] && !Shopify.designMode) return;
  try {
    
function polishFeminineCart() {
  const config = document.querySelector('[data-feminine-cart-polish]');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = 'true';
  const main = document.querySelector('main');
  if (!main) return;
  const update = () => {
    main.querySelectorAll('.tbtDiscountCombine').forEach((box,index) => {
      box.toggleAttribute('data-feminine-duplicate', index > 0);
      const heading=box.querySelector('.dcbHeading');
      if(heading && heading.textContent !== config.dataset.heading) heading.textContent=config.dataset.heading;
      const input=box.querySelector('.dcbInput');
      if(input) { input.placeholder=config.dataset.placeholder; input.setAttribute('aria-label',config.dataset.placeholder); }
      const apply=box.querySelector('.dcbButton');
      if(apply && apply.textContent.trim()==='Apply') apply.textContent=config.dataset.apply;
      const checkout=box.querySelector('.dcCheckout');
      if(checkout && checkout.textContent.trim()==='Checkout') checkout.textContent=config.dataset.checkout;
    });
  };
  update();
  new MutationObserver(update).observe(main,{childList:true,subtree:true});
}
polishFeminineCart();
document.addEventListener('shopify:section:load',polishFeminineCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feminine-launch-popup"]) return;
  try {
    
(()=>{
 const popup=document.querySelector('.feminine-launch');if(!popup)return;
 const video=popup.querySelector('video');const key='feminine-vitamin-c-launch-dismissed';
 let dismissed=false;try{dismissed=sessionStorage.getItem(key)==='1';}catch{}
 popup.querySelector('button').addEventListener('click',()=>popup.close());
 popup.addEventListener('click',event=>{if(event.target===popup){const r=popup.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)popup.close();}});
 popup.addEventListener('close',()=>{video.pause();try{sessionStorage.setItem(key,'1');}catch{}});
 const show=()=>{
  if(document.hidden)return;
  const others=[...document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,[aria-modal="true"],dialog[open]')].filter(el=>{const r=el.getBoundingClientRect();const style=getComputedStyle(el);return el!==popup&&r.width>10&&r.height>10&&style.visibility==='visible'&&Number(style.opacity)>0&&el.getAttribute('aria-hidden')!=='true';});
  if(others.length){setTimeout(show,2000);return;}
  popup.showModal();video.load();if(!matchMedia('(prefers-reduced-motion: reduce)').matches)video.play().catch(()=>{});
 };
 if(!dismissed)setTimeout(show,8000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feminine-skin-quiz"]) return;
  try {
    
function initFeminineQuiz(root) {
  if (!root || root.dataset.quizReady) return;
  root.dataset.quizReady = 'true';
  const form = root.querySelector('[data-skin-quiz]');
  const steps = [...form.querySelectorAll('fieldset')];
  const next = form.querySelector('[data-next]');
  const back = form.querySelector('[data-back]');
  const current = form.querySelector('[data-current]');
  const total = form.querySelector('[data-total]');
  const results = root.querySelector('[data-results]');
  const addSmall = root.querySelector('[data-add-small]');
  const addComplete = root.querySelector('[data-add-complete]');
  const cartMessage = root.querySelector('[data-cart-message]');
  const excludedWords = ['kalahari','cf ceuticals','cf cuticals','udgår','udsalg'];
  const rawProducts = JSON.parse(root.querySelector('[data-products]').textContent || '[]');
  const uniqueProducts = [...new Map(rawProducts.map(product => [(product.handle || product.url) + '|' + product.category, product])).values()];
  const products = uniqueProducts.filter(product => product.available && !excludedWords.some(word => product.text.includes(word)) && !(product.tags || []).some(tag => String(tag).toLowerCase() === 'quiz:exclude'));
  const quizTags = product => (product.tags || []).map(tag => String(tag).toLowerCase()).filter(tag => tag.startsWith('quiz:'));
  let step = 0;
  let smallRoutine = [];
  let completeRoutine = [];
  total.textContent = 11;

  const words = {
    dry: ['dry','tør','nourish','nærende','rich','repair','lipid','cream'],
    combination: ['balance','balancing','combination','kombineret','toner','light'],
    oily: ['purify','purifying','clear','blemish','uren','pore','carbon','gel'],
    normal: ['gentle','daily','normal','balance','glow'],
    moisture: ['moisture','moistur','hydra','hyaluron','fugt','plump','glow'],
    sensitive: ['sensitive','calm','soothing','gentle','delicate','redness','repair'],
    blemishes: ['purify','clear','blemish','pore','carbon','salicy','deep'],
    age: ['age','anti-age','firm','lift','collagen','miracle','repair','retinol'],
    pigment: ['bright','glow','pigment','vitamin c','uneven','radiance'],
    cleanser: ['cleanser','cleansing','rens','micellar','face wash'],
    serum: ['serum','drops','concentrate','booster'],
    cream: ['cream','creme','moisturizer','balm','lotion'],
    spf: ['spf','sunscreen','solbeskyttelse'],
    mask: ['mask','maske'],
    toner: ['toner','mist','essence']
  };

  function activeSteps() {
    const areas = value('whole_routine');
    return steps.filter(item => {
      if (!item.dataset.area) return true;
      if (item.dataset.area === 'nutrition') return !areas || areas === 'all';
      if (item.dataset.area === 'inside') return (!areas || areas === 'all') && value('inside') !== 'none';
      if (item.dataset.area === 'beauty') return !areas || ['all','beauty'].includes(areas);
      if (item.dataset.area === 'body') return !areas || ['all','skin_body'].includes(areas);
      if (item.dataset.area === 'hair') return !areas || ['all','skin_hair'].includes(areas);
      return false;
    });
  }
  function showStep(index) {
    step = index;
    const visibleSteps = activeSteps();
    const position = visibleSteps.indexOf(steps[step]);
    steps.forEach((item, i) => item.hidden = i !== step);
    back.hidden = position === 0;
    next.textContent = position === visibleSteps.length - 1 ? 'Se min rutine' : 'Næste';
    current.textContent = position + 1;
    total.textContent = visibleSteps.length;
    steps[step].querySelector('legend span').textContent = String(position + 1).padStart(2,'0');
  }

  function value(name) {
    return new FormData(form).get(name) || '';
  }

  function hasAny(text, list) {
    return (list || []).some(word => text.includes(word));
  }
  function hasQuiz(product, tags) {
    const own = quizTags(product);
    return (tags || []).some(tag => own.includes(`quiz:${tag}`));
  }

  function buildResults() {
    const after = value('after');
    const midday = value('midday');
    let skin = 'normal';
    if (after === 'tight' || midday === 'dry') skin = 'dry';
    if (after === 'varies' || midday === 'tzone') skin = 'combination';
    if (after === 'oily' || midday === 'shiny') skin = 'oily';
    const answers = {
      skin,
      goal: value('goal'),
      reactive: value('reactive'),
      active: value('active'),
      routine: value('routine'),
      makeup: value('makeup'),
      tool: value('tool'),
      inside: value('inside'),
      lifestyle: value('inside_lifestyle'),
      wholeRoutine: value('whole_routine'),
      bodyNeed: value('body_need'),
      hairNeed: value('hair_need')
    };
    const skincare = products.filter(product => product.category === 'Hudpleje' && !hasQuiz(product,['hair','makeup','tool']));
    const needsGentleRoutine = answers.reactive !== 'no' || answers.goal === 'sensitive' || answers.active === 'new';
    const strongActive = product => hasQuiz(product, ['advanced','peel']) || /\b(retinol|retinal|retinoid|retinoids|aha|bha|glycolic|salicylic)\b|strong peel|glykol|salicyl/i.test(product.title);
    const isSensitiveProfile = answers.reactive === 'yes' || answers.goal === 'sensitive';
    const gentleMatch = product => hasQuiz(product, ['sensitive','barrier','balanced']) || /gentle|delicate|calming|sensitive/i.test(product.title);
    const eligibleSkincare = skincare.filter(product => (!needsGentleRoutine || !strongActive(product)) && (!isSensitiveProfile || gentleMatch(product)));
    const scored = eligibleSkincare.map(product => {
      let score = 0;
      if (hasAny(product.text, words[answers.skin] || [])) score += 4;
      if (hasQuiz(product,[answers.skin, ...(answers.skin === 'normal' ? ['balanced'] : [])])) score += 10;
      if (hasAny(product.text, words[answers.goal] || [])) score += 6;
      if (hasQuiz(product,[answers.goal])) score += 14;
      if (answers.reactive === 'yes' && hasAny(product.text, words.sensitive)) score += 5;
      if (answers.reactive === 'yes' && hasQuiz(product,['sensitive','barrier'])) score += 14;
      if (answers.reactive === 'yes' && hasQuiz(product,['advanced','peel'])) score -= 25;
      if (answers.active === 'new' && hasQuiz(product,['advanced','peel'])) score -= 18;
      if (answers.reactive === 'yes' && hasAny(product.text, ['strong','peel','retinol','retinal','acid','aha','bha','glycol','salicy'])) score -= 12;
      if (answers.active === 'new' && hasAny(product.text, ['gentle','mild','delicate','balance'])) score += 3;
      if (answers.active === 'new' && hasAny(product.text, ['peel','retinol','retinal','acid','aha','bha','glycol','salicy','intensive'])) score -= 8;
      if (answers.active === 'experienced' && hasAny(product.text, ['serum','booster','concentrate','active'])) score += 2;
      if (answers.reactive === 'yes' && strongActive(product)) score = -50;
      return { ...product, score };
    });
    const chooseSkincare = (types, desired) => {
      const selected = [];
      types.forEach(type => {
      const candidate = scored.filter(product => !/\b(lip|eye|body|hand|foot)\b|øjen|læbe|krops|hånd|fod/.test(product.title.toLowerCase()) && product.score >= 0 && !selected.includes(product) && (hasQuiz(product,[type, ...(type === 'toner' ? ['mist'] : [])]) || (!quizTags(product).some(tag => ['cleanser','serum','cream','spf','mask','toner','peel'].some(kind => tag === 'quiz:'+kind)) && hasAny(product.title.toLowerCase(), words[type]))))
        .sort((a,b) => b.score - a.score)[0];
      if (candidate && selected.length < desired) selected.push(candidate);
      });
      return selected;
    };
    const small = chooseSkincare(['cleanser','cream','spf'], 3);
    const fullSkin = chooseSkincare(answers.wholeRoutine === 'essentials' ? ['cleanser','serum','cream','spf'] : ['cleanser','toner','serum','cream','mask','spf'], answers.wholeRoutine === 'essentials' ? 4 : 6);
    const pickTagged = (category, limit, wanted, eligible = () => true) => products
      .filter(product => product.category === category && eligible(product))
      .map(product => ({...product, score: (wanted || []).reduce((score, tag, index) => score + (hasQuiz(product,[tag]) ? 20 - index : 0), 0)}))
      .filter(product => product.score > 0)
      .sort((a,b) => b.score - a.score || a.handle.localeCompare(b.handle)).slice(0, limit);
    const wantsAll = answers.wholeRoutine === 'all';
    const wantsBody = wantsAll || answers.wholeRoutine === 'skin_body';
    const wantsHair = wantsAll || answers.wholeRoutine === 'skin_hair';
    const wantsBeauty = wantsAll || answers.wholeRoutine === 'beauty';
    const bodyTags = {dry:['moisture','dry'],sensitive:['sensitive','barrier'],ritual:['ritual','massage'],simple:['cleanse','moisture']}[answers.bodyNeed] || [];
    const body = wantsBody ? pickTagged('Kropspleje', answers.routine === 'simple' ? 1 : 2, bodyTags, product => !hasQuiz(product,['intimate','hands','feet','legs','aroma'])) : [];
    const hairTags = {dry:['dry-hair'],sensitive:['sensitive'],dandruff:['dandruff'],volume:['volume'],repair:['repair']}[answers.hairNeed] || [];
    const hair = wantsHair ? pickTagged('Hårpleje', answers.routine === 'simple' ? 1 : 2, hairTags) : [];
    const toolTags = {massage:['massage'],cleanse:['cleanse'],precision:['mask'],simple:['cleanse']}[answers.tool] || [];
    const chosenTools = wantsBeauty ? pickTagged('Redskab', answers.routine === 'simple' ? 1 : 2, toolTags, product => !hasQuiz(product,['nutrition-accessory','hair'])) : [];
    const makeupTags = {glow:['glow'],coverage:['coverage'],eyes_lips:['eyes','lips','brows'],minimal:['glow','coverage']}[answers.makeup] || [];
    const chosenMakeup = wantsBeauty ? pickTagged('Makeup', answers.routine === 'simple' ? 1 : 2, makeupTags, product => !hasQuiz(product,['refill'])) : [];
    const nutritionTags = {skin:['skin'],hair_nails:['hair-nails'],energy:['energy'],digestion:['digestion'],menopause:['menopause'],calm:['calm'],foundation:['foundation','omega']}[answers.inside] || [];
    const wantsSupplements = wantsAll && answers.inside !== 'none';
    const supplements = wantsSupplements ? pickTagged('Næring indefra', 1, nutritionTags, product =>
      product.handle !== 'nani-blaeretang-90-kapsler' &&
      (!hasQuiz(product,['menopause']) || answers.inside === 'menopause') &&
      (answers.lifestyle !== 'plant_based' || hasQuiz(product,['plant-based','tea'])) &&
      (!hasQuiz(product,['active']) || answers.lifestyle === 'active')
    ) : [];
    const focusedExtras = answers.wholeRoutine === 'essentials' ? [] : [...body.slice(0,1), ...hair.slice(0,1), ...chosenTools.slice(0,1), ...chosenMakeup.slice(0,1), ...supplements.slice(0,1)].slice(0,3);
    const extras = [...body, ...chosenTools, ...chosenMakeup, ...hair, ...supplements];
    const categoryOrder = ['Hudpleje','Kropspleje','Hårpleje','Makeup','Redskab','Næring indefra'];
    const sortRoutine = list => [...list].sort((a,b) => categoryOrder.indexOf(a.category) - categoryOrder.indexOf(b.category));
    smallRoutine = [...small, ...focusedExtras].filter(product => product.variantId && !product.requiresSelection);
    const dedupe = list => [...new Map(list.map(product => [product.handle || product.url, product])).values()];
    smallRoutine = sortRoutine(dedupe(smallRoutine));
    completeRoutine = sortRoutine(dedupe([...fullSkin, ...extras].filter(product => product.variantId && !product.requiresSelection)));

    root.querySelector('[data-summary]').textContent = answers.routine === 'simple'
      ? 'Vi starter med dine vigtigste match. Vil du gå videre, finder du også en bredere rutine baseret på de områder, du selv har valgt.'
      : 'Her er hele din Feminine-rutine. Hvert valg er sorteret ud fra dine svar om hud, de områder du har valgt, ritualer og eventuel næring indefra.';
    const reasonFor = product => {
      const tags = quizTags(product);
      if (product.category === 'Hudpleje' && answers.reactive === 'yes' && (tags.includes('quiz:sensitive') || tags.includes('quiz:barrier'))) return 'Udvalgt med fokus på en mere sensitiv eller reaktiv hud.';
      if (product.category === 'Hudpleje' && tags.includes('quiz:'+answers.goal)) return 'Matcher det hudmål, du har prioriteret i testen.';
      if (product.category === 'Kropspleje') return 'Valgt som et relevant supplement til din kropsrutine.';
      if (product.category === 'Hårpleje') return 'Valgt til den hår- og hovedbundsdel, du ønsker med.';
      if (product.category === 'Makeup') return 'Matcher dit ønskede makeup-udtryk.';
      if (product.category === 'Redskab') return 'Understøtter det ritual, du foretrækker.';
      if (product.category === 'Næring indefra') return 'Vises ud fra din interesse for næring indefra. Se indhold og anvendelse på produktet.';
      return 'Udvalgt ud fra kombinationen af dine svar.';
    };
    const cards = productsToShow => productsToShow.map(product => `
      <article class="fsq__card">
        <a href="${product.url}"><img src="${product.image}" alt="${product.title.replace(/\"/g, '&quot;')}" loading="lazy" width="700" height="700"></a>
        <div><span class="fsq__category">${product.category}</span><h3><a href="${product.url}">${product.title}</a></h3><p class="fsq__why">${reasonFor(product)}</p><p>${product.price}${product.variantTitle && product.variantTitle !== "Default Title" ? " · " + product.variantTitle : ""}</p><div class="fsq__card-actions">${product.requiresSelection ? `<a class="fsq__card-link" href="${product.url}">Vælg variant</a>` : `<button type="button" class="fsq__card-link" data-add-one="${product.variantId}">Tilføj</button>`}<a class="fsq__card-link fsq__card-link--quiet" href="${product.url}">Se produkt</a></div></div>
      </article>`).join('');
    root.querySelector('[data-grid-small]').innerHTML = cards(sortRoutine(dedupe([...small, ...focusedExtras])));
    const bundleLabel = list => list.length ? 'Tilføj ' + list.length + (list.length === 1 ? ' produkt' : ' produkter') + ' til kurven' : 'Vælg varianter på produkterne';
    addSmall.textContent = bundleLabel(smallRoutine);
    addComplete.textContent = bundleLabel(completeRoutine);
    addSmall.disabled = !smallRoutine.length;
    addComplete.disabled = !completeRoutine.length;
    root.querySelector('[data-grid-complete]').innerHTML = cards(sortRoutine(dedupe([...fullSkin, ...extras])));
    form.hidden = true;
    results.hidden = false;
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function addToCart(button, routine) {
    if (!routine.length) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Tilføjer rutinen…';
    cartMessage.textContent = '';
    try {
      const response = await fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: routine.map(product => ({ id: product.variantId, quantity: 1 }))
        })
      });
      if (!response.ok) throw new Error('Rutinen kunne ikke tilføjes');
      cartMessage.textContent = 'Rutinen er lagt i kurven. Du sendes videre nu.';
      window.location.href = root.dataset.cartUrl;
    } catch (error) {
      cartMessage.textContent = 'Et eller flere produkter kunne ikke tilføjes. Prøv igen, eller tilføj produkterne enkeltvis.';
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }
  root.addEventListener('click', async event => {
    const button = event.target.closest('[data-add-one]');
    if (!button) return;
    const id = button.dataset.addOne;
    const original = button.textContent;
    button.disabled = true; button.textContent = 'Tilføjer…';
    try {
      const response = await fetch(root.dataset.cartAddUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
      if (!response.ok) throw new Error('add');
      button.textContent = 'Tilføjet ✓';
      cartMessage.textContent = 'Produktet er lagt i kurven. ';
      const cartLink = document.createElement('a'); cartLink.href = root.dataset.cartUrl; cartLink.textContent = 'Se kurv'; cartMessage.appendChild(cartLink);
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(el => { const count = parseInt(el.textContent, 10); if (Number.isFinite(count)) el.textContent = String(count + 1); });
    } catch(e) { button.disabled = false; button.textContent = original; cartMessage.textContent = 'Produktet kunne ikke tilføjes. Prøv igen eller vælg Se produkt.'; }
  });
  addSmall.addEventListener('click', () => addToCart(addSmall, smallRoutine));
  addComplete.addEventListener('click', () => addToCart(addComplete, completeRoutine));

  form.addEventListener('change', () => showStep(step));
  form.addEventListener('submit', event => { event.preventDefault(); next.click(); });
  next.addEventListener('click', () => {
    const chosen = steps[step].querySelector('input:checked');
    if (!chosen) { steps[step].classList.add('fsq__invalid'); return; }
    steps[step].classList.remove('fsq__invalid');
    const remaining = activeSteps().filter(item => steps.indexOf(item) > step);
    if (remaining.length) showStep(steps.indexOf(remaining[0])); else buildResults();
  });
  back.addEventListener('click', () => { const previous = activeSteps().filter(item => steps.indexOf(item) < step); if (previous.length) showStep(steps.indexOf(previous[previous.length-1])); });
  showStep(0);
  root.querySelector('[data-restart]').addEventListener('click', () => {
    form.reset(); smallRoutine = []; completeRoutine = []; cartMessage.textContent = ''; results.hidden = true; form.hidden = false; showStep(0);
    root.querySelector('.fsq__header').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
document.querySelectorAll('.fsq').forEach(initFeminineQuiz);
document.addEventListener('shopify:section:load', event => initFeminineQuiz(event.target.querySelector('.fsq')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feminine-treatment-page"]) return;
  try {
    
(function () {
  function revealTreatment() {
    if (!window.location.hash) return;
    var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (!target || !target.closest('.f-treatment')) return;
    if (target.matches('details')) target.open = true;
    requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
  }
  window.addEventListener('hashchange', revealTreatment);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealTreatment);
  else revealTreatment();
})();

  } catch(e) { console.error(e); }
})();
})();
